import { ISelectOption } from "@common/components/forms";
import { StateModel } from "@common/models";
import { StateService } from "@common/services";
import { orderBy } from "lodash";
import { computed, flow, makeObservable, observable } from "mobx";

export class StateStore {


    @observable states: StateModel[] = [] as Array<StateModel>;
    @computed get stateSelectOptions() {
        return orderBy(this.states, []).map(u => ({ label: `${u.name}`, value: u.stateId })) as ISelectOption[]
    }
    constructor() {
        makeObservable(this, undefined, { autoBind: true });
    }
    getStates = flow(function* (this: StateStore) {
        this.states = yield StateService.getStates({ showError: true, errorMessage: "Failed to get State." });
    });

    saveState = flow(function* (this: StateStore, state: StateModel) {
        const options = {
            showSuccess: true,
            successMessage: state.stateId !== 0 ? "State successfully updated." : "State successfully created.",
            showError: true,
            errorMessage: "Failed to update State."

        };

        yield StateService.upsertState(state, options);
    });
}
